import { useTranslation } from "react-i18next";
import { DashboardCard } from "@/components/common/DashboardCard";
import { Spinner } from "@/components/ui/v2/spinner";
import { PATHS } from "@/routes/paths";
import { useGetUpcomingEventsQuery } from "@/services/(my-space)/api.events";
import { formatDate } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { EventStrip } from "./event-stip";

const PRIMARY = "100,56,255";

export const UpcomingEventsWidget = () => {
  const { t } = useTranslation("my-space");

  const { data: { data: upcomingEvents } = {}, isLoading: isFetchingEvents } =
    useGetUpcomingEventsQuery({});

  const EVENT_COLORS = [
    "var(--color-warning-muted)",
    "var(--color-danger-muted)",
    "var(--color-info-muted)",
    "var(--color-danger-muted)",
    "var(--color-success-muted)",
    "var(--color-info-muted)",
  ];

  const mappedEvents =
    upcomingEvents?.slice(0, 5)?.map((event, index) => ({
      title: event.title,
      subTitle: event.status,
      date: event.startDateTime,
      color: EVENT_COLORS[index % EVENT_COLORS.length],
      image: undefined,
    })) ?? [];

  return (
    <DashboardCard
      icon="/icons/interface-icons/stats/events/icon-3d-calendar.png"
      title={t("dashboard.upcoming_events")}
      action={{
        label: t("ui.view_all_x"),
        link: PATHS.MY_SPACE.MS_EVENT_PATHS.ROOT,
      }}
    >
      {isFetchingEvents ? (
        <Spinner />
      ) : mappedEvents.length === 0 ? (
        <div
          className="h-full rounded-xl border flex flex-col items-center justify-center gap-3"
          style={{
            background: `linear-gradient(150deg, rgba(${PRIMARY},0.05) 0%, rgba(${PRIMARY},0.10) 100%)`,
            borderColor: `rgba(${PRIMARY},0.20)`,
          }}
        >
          <div
            className="rounded-full p-4"
            style={{ background: `rgba(${PRIMARY},0.08)` }}
          >
            <CalendarIcon className="w-7 h-7 text-primary opacity-50" />
          </div>
          <div className="text-center">
            <p className="text-sm font-semibold text-gray-500">
              {t("ui.no_upcoming_events")}
            </p>
            <p className="text-xs text-gray-400 mt-0.5">
              {t("ui.your_scheduled_events_will_appear_here")}
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          {mappedEvents.map((data, i) => (
            <EventStrip
              key={i}
              title={data.title}
              image={data.image}
              color={data.color}
              subTitle={data.subTitle}
              date={formatDate(data.date, "dd MMM, yyyy")}
            />
          ))}
        </div>
      )}
    </DashboardCard>
  );
};
